const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const digitsAndSpacesRegex = /^[0-9\s]*$/
//only letters and spaces regex

const onlyLettersAndSpaces = /^[A-Za-zА-Яа-яÇĞIİÖŞÜçğii̇öşü\s]*$/
const onlyRussianLettersAndSpacesRegex = /^[А-Яа-я.:/\-"'@#$%^&*=|,\\\s0-9]*$/
const onlyEnglishLettersAndSpacesRegex = /^[A-Za-z.:/\-"'@#$%^&*=|,\\\s0-9]*$/
const onlyTurkishLettersAndSpacesRegex = /^[A-Za-zÇĞIİÖŞÜçğiıöşü.:/\-"'@#$%^&*=|,\\\s0-9]*$/

export const validators = {
    NotEmpty(value) {
        if (value === "") {
            return "this field is required"  
        }
        return null
    },
    ValidateEmail (value) {
        value = value.trim();
        if(!emailRegex.test(value))
            return "Field must contain email address"
        return null 
    },
    ValidateLength(value, min = 0, max = Infinity) {
        if(value.length < min) {
            return `min: ${min}`
        }
        if(value.length > max) {
            return `max: ${max}`
        }
        return null
    },
    ValidateNumber(value) {
        if(!value || isNaN(value))
            return "This field must be a number"
        return null 
    },
    ValidateURL(value) {
        try{
            new URL(value)
        } catch(_) {
            return "This field must be an URL"
        }
    },
    HasOnlyLettersAndSpaces(value) {
        if(!onlyLettersAndSpaces.test(value))
            return "Field must contain only letters and spaces"
        return null 
    },
    HasOnlyRussianLetters(value) {
        if(!onlyRussianLettersAndSpacesRegex.test(value))
            return "Field must contain only russian letters and spaces"
        return null
    },
    HasOnlyEnglishLettersSymbolsAndSpecialSigns(value) {
        if(!onlyEnglishLettersAndSpacesRegex.test(value))
            return "Field must contain only english letters"
        return null
    },
    HasOnlyTurkishLetters(value) {
        if(!onlyTurkishLettersAndSpacesRegex.test(value))
            return "Field must contain only letters and spaces"
        return null
    },
    HasOnlyDigitsAndSpaces(value) {
        if(!digitsAndSpacesRegex.test(value))
            return "Field must contain only turkish letters and spaces"
        return null 
    },
    ValidatePhone(value) {
        value = value.replace(/\s/g, '').replace(/-/g, '').replace(/'+/g, '')
        let err = this.ValidateNumber(value)
        if (err) return "not valid phone number"
        if(value.length < 7) {
            return "min: 7"
        }
        return null 
    },
    ValidateUserName(value) {
        if(value.length < 2) {
            return "min: 2"
        }
        if(value.length > 100) {
            return "max: 100"
        }
        if( this.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value) || 
            this.HasOnlyLettersAndSpaces(value)) {
            return "Field must contain only english letters"
        }
        return null 
    },
    ValidateCompanyName(value) {
        if(!value) {
            return null
        }
        if(value.length < 2) {
            return "min: 2"
        }
        if(!onlyEnglishLettersAndSpacesRegex.test(value))
            return "Field must contain only english letters"
        return null 
    },
    ValidateReceiverAddress(value) {
        if(!value) {
            return "this field is required"
        }
        if(value.length < 2) {
            return "min: 2"
        }
        if(value.length > 250) {
            return "max: 250"
        }
        if(this.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value)) {
            return this.HasOnlyEnglishLettersSymbolsAndSpecialSigns(value)
        }
        return null 
    }
}